import { render, staticRenderFns } from "./Consignment.vue?vue&type=template&id=4170e46a&scoped=true&"
import script from "./Consignment.vue?vue&type=script&lang=js&"
export * from "./Consignment.vue?vue&type=script&lang=js&"
import style0 from "./Consignment.vue?vue&type=style&index=0&id=4170e46a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4170e46a",
  null
  
)

export default component.exports